import React, { useEffect, useRef, useState } from "react";
import { Card } from "react-md";
import { withRouter } from "react-router-dom";
import MSplitter from "components/Shared/MSplitter.tsx";
import { QualityAssuranceAgentList } from "interfaces/Mueller.Business.Models.ts";
import { getQADepartmentList } from "requests/qualityAssurance/index.ts";
import { getSearchParameter } from "../../components/Shared/Functions";
import { phoneNumberFormatter } from "components/Shared/Formatters";
import { AgentProfile } from "containers/QualityAssurance";
import MGrid, {
  ACTION_CONFIGURE,
  ACTION_REFRESH,
  ACTION_MAP,
  FILTER_TYPE_MULTI_SELECT,
  MGridColumnDefinition,
} from "components/Shared/MGrid.tsx";

const gridCols: MGridColumnDefinition[] = [
  { dataSource: "supervisorName", name: "Supervisor", width: 170, filterType: FILTER_TYPE_MULTI_SELECT },
  { dataSource: "name", name: "Name", width: 200 },
  { dataSource: "address", name: "Address", width: 200 },
  { dataSource: "city", name: "City", width: 200 },
  { dataSource: "state", name: "State", width: 200 },
  { dataSource: "postalCode", name: "Zip", width: 60 },
  { dataSource: "homePhone", name: "Home Phone", width: 120, valueFormatter: phoneNumberFormatter },
  { dataSource: "emailAddress", name: "Email", width: 200 },
  { dataSource: "auditPercentage", name: "% of Cases to Audit", width: 120 },
  { dataSource: "rejectionsAuditPercentage", name: "% of Rejections to Audit", width: 120},
  { dataSource: "payrollEmployeeId", name: "Payroll ID", width: 200 },
].map(c => ({ key: c.dataSource, resizable: true, ...c }));

interface IQADepartmentListProps {
  //Seems kind of pointless to define these both as any, but we use any for history everywhere else and location looks like it's passed to getSearchParameter which just takes any object as a parameter
  history: any,
  location: any,
}

const QADepartmentList = ({history, location} : IQADepartmentListProps) => {
  const [userList, setUserList] = useState<QualityAssuranceAgentList[]>(null);
  const [selectedUser, setSelectedUser] = useState<QualityAssuranceAgentList>();
  const mounted = useRef(true);

  useEffect(() => {
    getQADepartmentList(getSearchParameter(location), setUserList, () => setUserList([]), mounted);
    return () => { mounted.current = false; };
  }, []);

  const onRowClick = (rowIndex: number) => {
    setSelectedUser(userList[rowIndex]);
  };

  const navigateToAgent = () => {
    history.push({
      pathname: "/qa-agent-profile",
      state: { internetUserId: selectedUser.internetUserId },
    });
  };

  return (
    <MSplitter
      firstChild={
        <div className="padding-page-content full-height">
          <Card className="full-height">
            <MGrid
              configurationId="QADepartmentList"
              headerText="QA Department List"
              columnDefinitions={gridCols}
              data={userList}
              isFetchingData={!userList}
              actions={[ACTION_CONFIGURE, ACTION_REFRESH, ACTION_MAP]}
              onRowClick={onRowClick}
            />
          </Card>
        </div>
      }
      secondChild={selectedUser && <AgentProfile internetUserId={selectedUser.internetUserId} verticalDisplay supervisorName={selectedUser.supervisorName}/>}
      secondChildTitle={{
        title: "Profile",
        buttons: [
          { icon: "fullscreen", onClick: navigateToAgent },
          { icon: "close", onClick: () => setSelectedUser(null) }
        ],
      }}
    />
  );
};

export default withRouter(QADepartmentList);